import { COMPANY_BASE_URL } from '@/shared/constants/envs';

import { FAQ_DATA } from '../../constants/landing-constants';

// FAQPage Schema - makes FAQ content eligible for rich results
// This should only be rendered on pages that actually display the FAQ
const faqPageSchema = {
	'@context': 'https://schema.org',
	'@type': 'FAQPage',
	'@id': `${COMPANY_BASE_URL}/#faq`,
	mainEntity: FAQ_DATA.filter((faq) => !faq.isStatic).map((faq) => ({
		'@type': 'Question',
		name: faq.question,
		acceptedAnswer: {
			'@type': 'Answer',
			text: faq.answer,
		},
	})),
};

/**
 * FAQStructuredData adds JSON-LD FAQPage schema markup.
 * Should only be used on pages that actually display the FAQ section.
 */
export function FAQStructuredData() {
	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(faqPageSchema),
			}}
		/>
	);
}
